import { render, staticRenderFns } from "./TableEdited.vue?vue&type=template&id=0e48f73a"
import script from "./TableEdited.vue?vue&type=script&setup=true&lang=js"
export * from "./TableEdited.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports